import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import FilterHeading from './FilterHeading';
import { StyledChip } from '../Chip';
import FilterOverlay from './FilterOverlay';
import breakpoints from '../Theme/breakpoints';

const CategoryFilterWrapper = styled.div<{ loadingProp?: boolean }>`
  overflow: hidden;
  position: relative;
  margin: 0 0 12px;
  filter: blur(${({ loadingProp }) => (loadingProp ? '2px' : '0px')});


  @media (min-width: ${breakpoints.md}px) {
    margin: 0 0 32px;
  }

  .mdc-chip--selected {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
  }
`;

const CategoryChip = styled(StyledChip)`
  &&& {
    margin: 4px 4px 4px 0;
    font-size: 0.75rem;
    font-weight: bold;
  }
`;

const ChipSetWrapper = styled.div<{ modal?: boolean }>`
  width: auto;
  position: relative;

  && {
    padding: 4px 12px 16px 0;
    margin-left: ${({ modal }) => (modal ? '0' : '16px')};
    display: flex;
    flex-wrap: nowrap;
    overflow-x: scroll;

    @media (min-width: ${breakpoints.md}px) {
      margin-left: 0;
      padding: 12px 0 0;
      display: block;
      overflow-x: visible;
    }
  }
`;

const categoryFilterPropertyTypes = {
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      handleInteraction: PropTypes.func,
    }).isRequired,
  ).isRequired,
  selectedCategory: PropTypes.string,
};

type CategoryFilterProperties = InferProps<
  typeof categoryFilterPropertyTypes
> & {
  loading?: boolean;
  modal?: boolean;
};

const CategoryFilter = ({
  name: filterName,
  title,
  categories,
  loading,
  selectedCategory,
  modal,
} : CategoryFilterProperties) => {
  const loadingValue = loading ?? false;
  const modalValue = modal ?? false;

  return (
    <CategoryFilterWrapper
      className="category-filter"
      loadingProp={loadingValue}
    >
      { loadingValue && <FilterOverlay /> }
      { title && (
        <FilterHeading tag="h2" modal={modalValue}>
          { title }
        </FilterHeading>
      )}
      <ChipSetWrapper modal={modalValue}>
        { categories.map(({ name, handleInteraction }) => (
          <CategoryChip
            key={`${filterName}-${name}`}
            id={`${filterName}-${name}`}
            data-testid={`${filterName}-${name}`}
            label={name}
            color={name === selectedCategory ? 'primary' : 'default'}
            onClick={handleInteraction ?? undefined}
          />
        ))}
      </ChipSetWrapper>
    </CategoryFilterWrapper>
  );
};

CategoryFilter.propTypes = categoryFilterPropertyTypes;

export default CategoryFilter;
